import React, { useMemo } from "react";
import { IProductDetail } from "../api-helpers/jomashop-graphql";
import has from "lodash/has"

interface IProps {
  className?: string
  productDetail: IProductDetail
}

const ProductSelling: React.FC<IProps> = (props) => {
  const { productDetail } = props

  const displayPriceItem = useMemo(() => {

    if (productDetail?.price) {

      const defaultPrice = productDetail?.payload?.metadata?.price?.USD?.was_price
      const nowPrice = productDetail?.payload?.metadata?.price?.USD?.now_price
      const hasDiscount = nowPrice < defaultPrice
      const hasPromoValue = has(productDetail?.payload?.metadata, 'promotext_value')

      return (
        <div className='flex flex-col pointer-events-none'>
          {hasDiscount ?
            <div className='flex gap-2 items-center h-[30px]'>
              {hasPromoValue ?
                <span
                  className='uppercase font-bold text-sm text-gray-700 py-[3px] px-[5px] rounded-sm bg-gray-100'>
                  {productDetail?.payload?.metadata?.price?.USD?.discount_formatted}
                </span>
                : null}

              <div className='flex gap-1 items-center'>
                <span className='text-gray-400 text-base'>Was </span>
                <span
                  className='line-through text-gray-400 text-base'>${defaultPrice}</span>
              </div>
            </div> : null}

          <div className='mt-1 flex flex-col'>
            <span
              className='font-bold text-2xl text-gray-700 pointer-events-none'>{productDetail?.payload?.metadata?.price?.USD?.now_price_formatted}</span>
          </div>
        </div>
      )
    }
    return <span
      className='font-bold text-2xl text-gray-700'>{productDetail?.payload?.metadata?.price?.USD?.now_price_formatted}</span>
  }, [productDetail.price, productDetail.payload])

  return (
    <div className='flex gap-4 my-6'>
      <a href={productDetail?.url} className="!no-underline">
        <img
          className='aspect-square object-cover w-full max-w-[120px] min-w-[120px] md:min-w-[220px] md:max-w-[220px]'
          src={productDetail?.image}
          alt={productDetail?.brand}/>
      </a>

      <div className='flex flex-col self-center items-start'>
        <h4 className='text-xl font-bold'>
          <a href={productDetail.url} className="!no-underline">{productDetail?.name}</a>
        </h4>
        <p className='text-sm bg-black text-white px-2 rounded-md uppercase font-medium'>{productDetail?.brand}</p>
        <div>{displayPriceItem}</div>
        <a
          href={productDetail?.url}
          className='w-[120px] !no-underline text-center mt-2 font-bold text-lg bg-gray-300 py-1 px-3 rounded-md'>
          BUY
        </a>
      </div>
    </div>
  )
}

export default ProductSelling